import { localisedValue } from "utils"

const statesTransformer = response => {
    const states = response?.states?.map(e => ({
        ...e,
        key: e?.id,
        label: localisedValue({ object: e, key: "name" }),
        value: e?.id?.toString(),
      }))
      return states
  }
  
  export default statesTransformer